// Account-path events for measurement. Storefront only: the hosted account pages and their
// extensions cannot publish storefront events, so Riordina / Verifica il lotto clicks inside
// account.oliottaviani.com are measured by Shopify's own customer-account analytics, not here.
//
// Each event goes to Shopify's custom-event bus (web pixels subscribe to it) and, when Google
// Tag Manager is on the page, to its dataLayer. Nothing is sent anywhere else.
//
// OlivIA (docs/superpowers/specs/2026-10-07-olivia-architecture-design.md §7.5): the band in
// assets/lab-olivia.js dispatches `lab:analytics` on document with { name, flags }. Only the
// names and boolean flags of OLIVIA_FLAGS pass, rebuilt in that order and without `page`, and
// only while the visitor's stored choice is valid and allows analytics
// (window.OlioConsentStore.readValid(), snippets/google-consent-mode.liquid), read at each
// event so a choice made after load counts from then on. Anything else is dropped with a
// console error that names the reason, never the values. The conversation works the same
// without any of these events.
(() => {
  const send = (name, payload) => {
    try { window.Shopify?.analytics?.publish?.(name, payload); } catch (error) { console.error('lab-events', error); }
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...payload });
  };
  const publish = (name, data) => send(name, { page: location.pathname, ...data });

  document.addEventListener('click', (event) => {
    const sheet = event.target.closest('shopify-account');
    if (sheet) { publish('lab_account_sheet_open', { signed_in: sheet.getAttribute('data-signed-in') === 'true' }); return; }
    const tracked = event.target.closest('[data-lab-event]');
    if (tracked) publish(tracked.dataset.labEvent, { href: tracked.getAttribute('href') || '' });
  }, { passive: true });

  // The one allowlist: each OlivIA event name and the exact boolean flags it carries.
  const OLIVIA_FLAGS = {
    olivia_ask: ['has_product'],
    olivia_answer: ['has_card', 'errored'],
    olivia_cta: ['is_cart'],
  };
  const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
  const analyticsAllowed = () => window.OlioConsentStore?.readValid?.()?.analytics === true;

  // { flags } rebuilt in allowlist order, or { reason } the event is dropped for.
  const oliviaFlags = (detail) => {
    if (!isRecord(detail) || typeof detail.name !== 'string' || !Object.hasOwn(OLIVIA_FLAGS, detail.name)) {
      return { reason: 'unknown event name' };
    }
    const allowed = OLIVIA_FLAGS[detail.name];
    const { flags } = detail;
    if (!isRecord(flags)) return { reason: `${detail.name}: flags must be an object` };
    if (Object.keys(flags).length !== allowed.length || !allowed.every((key) => Object.hasOwn(flags, key))) {
      return { reason: `${detail.name}: flags must be exactly ${allowed.join(', ')}` };
    }
    if (!allowed.every((key) => typeof flags[key] === 'boolean')) return { reason: `${detail.name}: flags must be booleans` };
    return { flags: Object.fromEntries(allowed.map((key) => [key, flags[key]])) };
  };

  document.addEventListener('lab:analytics', (event) => {
    const checked = oliviaFlags(event.detail);
    if (checked.reason) { console.error('lab-events: dropped lab:analytics,', checked.reason); return; }
    if (analyticsAllowed()) send(event.detail.name, checked.flags);
  });
})();
